// extracted by mini-css-extract-plugin
export default {"container":"CarrusellArrowLeft_container__-66-j"};